export var EnvironmentVariableType;
(function (EnvironmentVariableType) {
    EnvironmentVariableType["STRING"] = "string";
})(EnvironmentVariableType || (EnvironmentVariableType = {}));
//# sourceMappingURL=environment-variable.interface.js.map